import { render, staticRenderFns } from "./statustip.vue?vue&type=template&id=bf12d638&scoped=true&"
import script from "./statustip.vue?vue&type=script&lang=js&"
export * from "./statustip.vue?vue&type=script&lang=js&"
import style0 from "./statustip.vue?vue&type=style&index=0&id=bf12d638&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf12d638",
  null
  
)

export default component.exports